import { render, staticRenderFns } from "./resourceHeat.vue?vue&type=template&id=e2890728&scoped=true"
import script from "./resourceHeat.vue?vue&type=script&lang=js"
export * from "./resourceHeat.vue?vue&type=script&lang=js"
import style0 from "./resourceHeat.vue?vue&type=style&index=0&id=e2890728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2890728",
  null
  
)

export default component.exports